module.exports = __webpack_public_path__ + "img/trina.87696096.svg";